import(/* webpackMode: "eager" */ "/app/hub/src/app/global-error.tsx");
